import { SET_BOOK_LIST } from "../ActionName/ActionName";

const initialState = {
    bookList: [],
    timestamp: Date.now()
}

const BookReducer = (state = initialState, action) => {

    switch (action.type) {
        case SET_BOOK_LIST:
            return {
                ...state,
                bookList: action.value || [],
                timestamp: Date.now()
            }

        default:
            return state;
    }
}

export default BookReducer;
